// extracted by mini-css-extract-plugin
export default {"module":"MovementLifecycle_module__LNpLy","info":"MovementLifecycle_info__MFnf7","table":"MovementLifecycle_table__eFGO9","divider":"MovementLifecycle_divider__vZt6F"};